<template>
  <div v-if="current">
    <div class="row">
      <div class="col-md-6">
        <v-btn color="primary" @click="register()">Novo POP</v-btn>
      </div>
      <div class="col-md-6">&nbsp;</div>
    </div>
    <v-simple-table>
      <thead>
        <tr>
          <th>Nome</th>
          <th>Código</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.nome }}</td>
          <td>{{ item.codigo }}</td>
          <td>
            <v-btn small color="primary" @click="view(item.id)">detalhes</v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null
  }),
  created: function() {
    this.list();
  },
  methods: {
    list: function() {
      var me = this;
      var token = localStorage.getItem("token");
      api
        .get("/pop", { headers: { Authorization: "Bearer " + token } })
        .then(function(response) {
          me.current = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    view: function(id) {
      this.$router.push({ path: `/pop/${id}` });
    },
    register: function() {
      router.push({ path: "/pop/0" });
    }
  }
};
</script>